import { Injectable } from '@angular/core';

@Injectable()
export class UtilService {

    constructor() { }

    removeSpecialCharacter(item: string) {
        return item.replace(/[^0-9|^a-z]/gi, '');
    }

    cloneObject(object: any) {
        return JSON.parse(JSON.stringify(object));
    }

    swalMessageDelete(done: any, closeOnConfirm?: boolean) {
        if (!closeOnConfirm) {
            closeOnConfirm = false;
        }
        swal({
                title: "Você deseja realmente desativar este item?",
                text: "O item será desativado.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Desativar",
                cancelButtonText: "Cancelar",
                closeOnConfirm: closeOnConfirm
            },function() {
                return done();
            }
        );
    }

    swalMessageDeleteSuccess() {
        swal("Desativado!", 'Desativado com sucesso.', "success");
    }

    swalMessageDeleteError() {
        swal("Erro!", 'Não foi possível desativar o item.', "error");
    }

    swalMessagePostError() {
        swal("Erro!", 'Não foi salvar os dados.', "error");
    }

    swalMessageAddSuccess() {
        swal("Cadastrado!", "O item foi cadastrado com sucesso.", "success");
    }

    swalMessageEditSuccess() {
        swal("Editado!", "O item foi editado com sucesso.", "success");
    }

    swalMessageWarningCustom(message: string) {
        swal("Aviso!", message, "warning");
    }

    setSelectOnFormControl(form: any, item: string, object: any, arg?:string) {
        var tt: any = form.controls[item];
        if (arg) {
            tt.patchValue(object[arg]);
        } else {
            if (typeof object === 'string') {
                tt.patchValue(object);
            } else {
                tt.patchValue(object.id);
            }
        }
    }

    convertDateToString(date: any) {
        date = new Date(date);
        var day: number = date.getUTCDate();
        var month: number = date.getUTCMonth()+1;
        var year: number = date.getUTCFullYear();
        var monthS: string = month.toString();
        var dayS: string = day.toString();
        if (month < 10) {
            monthS = "0" + monthS;
        }
        if (day < 10) {
            dayS = "0" + dayS;
        }
        var newDate: string = dayS + "/" + monthS + "/" + year;
        return newDate;
    }

    convertStringToDate(date: string) {
        let newDate: any = false;
        let dateArray: Array<any> = date.split("/");
        if (dateArray.length === 3) {
            let day: number = Number(dateArray[0]);
            let month: number = Number(dateArray[1])-1;
            let year: number = Number(dateArray[2]);

            let time: any = new Date();

            if (month < 12 && day < 32) {
                newDate = new Date(year, month, day);
                newDate.setHours(time.getHours());
                newDate.setMinutes(time.getMinutes());
                return newDate;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    convertStringToDateTime(date: string, time: string) {
        let newDateTime: any = this.convertStringToDate(date);
        let timeArray: Array<any> = time.split(":");
        if (timeArray.length === 2) {
            let hours: number = Number(timeArray[0]);
            let minutes: number = Number(timeArray[1]);

            if (hours <= 24 && minutes <= 59) {
                newDateTime.setHours(hours);
                newDateTime.setMinutes(minutes);
                return newDateTime;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    convertTimeToString(date: any) {
        date = new Date(date);
        var hour: any = date.getHours();
        var minute: any = date.getMinutes();
        if (hour < 10) {
            hour = "0" + hour;
        }
        if (minute < 10) {
            minute = "0" + minute;
        }
        var newDate: string = hour + ":" + minute;
        return newDate;
    }

    disabledFutureDates(inputId: string) {
        let datePicker: any = $('#' + inputId);
        datePicker.datepicker({maxDate: "+0D" });
    }

    getCurrency(currency: any) {
        currency = currency.toString();
        currency = currency.replace(/\./g, '');
        currency = currency.replace(",", ".");
        currency = parseFloat(currency);

        return currency;
    }

    currencyFormat(newVal: any, start?: boolean) {
        let formatted:string = '',
            x:number, lenX:number;

        if (!newVal) {
            newVal = 0;
        } else {
            newVal = newVal.toString();
            if (start) {
                let point = newVal.indexOf(".");
                if (point === -1) {
                    newVal = newVal + '00';
                } else {
                    let afterPoint = newVal.slice(point + 1, newVal.length);
                    if (afterPoint.length < 2) {
                        newVal = newVal + '0';
                    }
                }

                newVal = newVal.replace(".", "");
            } else {
                findCharacter('.');
                findCharacter(',');
                newVal = newVal.replace(/\D/g, '').replace(/\./g, '').replace(/,/g, '').replace(/^0+/, '');
            }

            if (newVal.length == 2) newVal = '0' + newVal;
            if (newVal.length == 1) newVal = '00' + newVal;

            for (x = 0, lenX = newVal.length; x < lenX; x++) {
                var sep = '';
                if (x == 2) sep = ',';
                if (x > 3 && (x + 1) % 3 == 0) sep = '.';
                formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
            }

            newVal = formatted;
        }

        return newVal;

        function findCharacter(char: string) {
            let pos: number = newVal.lastIndexOf(char);
            if (pos !== -1) {
                let part2: any = newVal.slice((pos + 1), newVal.length);
                if (part2.length == 1) newVal = newVal + '0';
            }
        }
    }

    checkNumber(value: any) {
        let valueNumber = Number(value);

        if (isNaN(valueNumber)) {
            return '';
        }

        return value;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/util.service.ts
 **/